/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h3[_ngcontent-%COMP%]{color:RED}.barraMenu[_ngcontent-%COMP%]{flex-wrap:wrap;align-items:center;padding:8px 16px}#principal[_ngcontent-%COMP%]{display:block;margin-top:56px}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
